import styled, { createGlobalStyle } from "styled-components";
import { SliderInput, SliderTrack, SliderTrackHighlight, SliderHandle } from "@reach/slider";
import { position, rgba } from "polished";
import { createTriangleStyles } from "../../utils/create-triangle-styles.es.js";
const SliderGlobal = createGlobalStyle(({ disableUserSelect }) => ({
  "*": {
    userSelect: disableUserSelect ? "none" : void 0
  }
}));
const SliderInputImpl = styled(SliderInput)(
  ({ theme }) => ({
    color: theme.fontSize.color,
    cursor: "pointer",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    outline: "transparent",
    padding: 8,
    "&:active": {
      cursor: "grabbing"
    }
  }),
  ({ disabled }) => disabled ? {
    pointerEvents: "none"
  } : void 0
);
const SliderTrackImpl = styled(SliderTrack)({
  backgroundColor: "rgba(0,0,0,0.05)",
  borderRadius: 2,
  height: 4
});
const SliderTrackHighlightImpl = styled(SliderTrackHighlight)(({ theme }) => ({
  backgroundColor: theme.color.blue6,
  borderRadius: "inherit",
  ...position("absolute", 0, null, 0, 0)
}));
const SliderHandleImpl = styled(SliderHandle)(
  ({ theme }) => ({
    cursor: "grab",
    height: 20,
    outline: 0,
    position: "relative",
    top: "50%",
    touchAction: "none",
    transform: "translateY(-50%)",
    transformOrigin: "center",
    width: 32,
    "&::before": {
      backgroundColor: "#fff",
      border: `2px solid ${theme.color.blue6}`,
      borderRadius: "50%",
      boxSizing: "border-box",
      content: JSON.stringify(""),
      height: 14,
      left: "50%",
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      transition: "box-shadow 0.3s",
      width: 14
    },
    "&:focus::before": {
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    },
    "&:active": {
      cursor: "grabbing"
    }
  }),
  ({ disabled, theme }) => disabled ? {
    "&::before": {
      borderColor: theme.color.gray4
    },
    "&:focus::before": {
      boxShadow: "none"
    }
  } : void 0
);
const SliderValueDisplay = styled("div")(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, 0.85)",
  borderRadius: 4,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  color: "rgba(255, 255, 255, 0.85)",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  padding: "4px 8px",
  position: "absolute",
  transform: "translate(-50%, -50%) translateY(-18px)",
  whiteSpace: "pre-wrap",
  "&::before": createTriangleStyles({
    color: "rgba(0, 0, 0, 0.85)",
    justify: "center",
    placement: "top",
    size: 5
  })
}));
export {
  SliderGlobal,
  SliderHandleImpl,
  SliderInputImpl,
  SliderTrackHighlightImpl,
  SliderTrackImpl,
  SliderValueDisplay
};
